export interface MangaChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Manga {
  id: string;
  slug: string;
  title: string;
  author: string;
  category: string;
  coverImage: string;
  description: string;
  status: string;
  rating: number;
  views: number;
  tags: string[];
  chapters: MangaChapter[];
  updatedAt: string;
}

export const mangaList: Manga[] = [
  {
    id: "1",
    slug: "dushi-zhizun-kuangxu",
    title: "都市至尊狂婿",
    author: "绝世小白",
    category: "国漫",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20style%2C%20handsome%20male%20protagonist%20in%20modern%20city%20setting%2C%20dramatic%20lighting%2C%20urban%20fantasy%20theme%2C%20clean%20illustration%20with%20bold%20colors%2C%20manga%20cover%20design%2C%20simple%20gradient%20background&width=600&height=800&seq=manga-cover-01&orientation=portrait",
    description: "一代至尊强者重生归来，成为豪门弃婿。面对曾经羞辱他的家族和敌人，他将以无敌之姿，横扫一切！看至尊如何在都市中掀起腥风血雨，夺回属于自己的一切。",
    status: "连载中",
    rating: 9.5,
    views: 1280000,
    tags: ["热血", "都市", "逆袭", "至尊"],
    chapters: [
      { id: "c1-1", title: "第1话 重生归来", number: 1, updatedAt: "2026-08-01" },
      { id: "c1-2", title: "第2话 豪门弃婿", number: 2, updatedAt: "2026-08-02" },
      { id: "c1-3", title: "第3话 初露锋芒", number: 3, updatedAt: "2026-08-03" },
    ],
    updatedAt: "2026-08-03",
  },
  {
    id: "2",
    slug: "xianni-fanren-xiuxian",
    title: "仙逆",
    author: "耳根",
    category: "国漫",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manhua%20cover%2C%20cultivator%20in%20flowing%20white%20robes%2C%20celestial%20palace%20background%2C%20ethereal%20clouds%20and%20mist%2C%20fantasy%20illustration%20style%2C%20clean%20composition%2C%20soft%20mystical%20lighting&width=600&height=800&seq=manga-cover-02&orientation=portrait",
    description: "顺为凡，逆则仙，只在心中一念间。王林以平庸资质踏入修仙之路，凭借坚韧不拔的意志，一步步走向巅峰，最终逆天改命，成就一代传奇。",
    status: "连载中",
    rating: 9.7,
    views: 3560000,
    tags: ["修仙", "玄幻", "热血", "逆袭"],
    chapters: [
      { id: "c2-1", title: "第1话 平凡少年", number: 1, updatedAt: "2026-08-02" },
      { id: "c2-2", title: "第2话 踏入仙途", number: 2, updatedAt: "2026-08-03" },
      { id: "c2-3", title: "第3话 初次修炼", number: 3, updatedAt: "2026-08-04" },
    ],
    updatedAt: "2026-08-04",
  },
  {
    id: "3",
    slug: "dushi-xiuzhen-zuiqiang",
    title: "重生之都市修仙",
    author: "十里剑神",
    category: "国漫",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20urban%20cultivation%20manhua%20cover%2C%20young%20man%20with%20spiritual%20energy%20glowing%20around%20hands%2C%20modern%20city%20skyline%20mixing%20with%20fantasy%20elements%2C%20dynamic%20pose%2C%20vibrant%20illustration%2C%20clean%20minimal%20background&width=600&height=800&seq=manga-cover-03&orientation=portrait",
    description: "北玄仙尊重生回到地球的少年时代。这一世，他要弥补所有遗憾，守护珍视的人，让那些曾经伤害过他的人付出代价。九天十地，唯我独尊！",
    status: "连载中",
    rating: 9.4,
    views: 2890000,
    tags: ["修仙", "都市", "重生", "强者"],
    chapters: [
      { id: "c3-1", title: "第1话 仙尊重生", number: 1, updatedAt: "2026-08-01" },
      { id: "c3-2", title: "第2话 回到校园", number: 2, updatedAt: "2026-08-03" },
      { id: "c3-3", title: "第3话 初次出手", number: 3, updatedAt: "2026-08-04" },
    ],
    updatedAt: "2026-08-04",
  },
  {
    id: "4",
    slug: "hanman-gao-bang",
    title: "高攀",
    author: "Yeo-U",
    category: "韩漫",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20cover%20art%2C%20elegant%20beautiful%20woman%20and%20handsome%20man%20in%20luxurious%20setting%2C%20soft%20romantic%20lighting%2C%20clean%20illustration%20style%2C%20modern%20K-drama%20aesthetic%2C%20sophisticated%20composition&width=600&height=800&seq=manga-cover-04&orientation=portrait",
    description: "一个是高高在上的财阀继承人，一个是平凡普通的公司职员。两个本不该有交集的人，却在命运的安排下相遇。这是一段关于阶级、爱情与选择的故事。",
    status: "连载中",
    rating: 9.2,
    views: 1560000,
    tags: ["恋爱", "都市", "财阀", "韩漫"],
    chapters: [
      { id: "c4-1", title: "第1话 偶然相遇", number: 1, updatedAt: "2026-08-01" },
      { id: "c4-2", title: "第2话 第二次见面", number: 2, updatedAt: "2026-08-03" },
    ],
    updatedAt: "2026-08-03",
  },
  {
    id: "5",
    slug: "hanman-zongcai-mi-mi",
    title: "总裁的秘密",
    author: "Kim Yeon",
    category: "韩漫",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20office%20romance%20cover%2C%20charismatic%20CEO%20man%20in%20sharp%20suit%2C%20elegant%20office%20setting%2C%20mysterious%20atmosphere%2C%20dramatic%20lighting%2C%20clean%20romance%20manhwa%20style&width=600&height=800&seq=manga-cover-05&orientation=portrait",
    description: "公司里所有人都知道总裁冷酷无情，但没人知道他的秘密。新来的秘书意外发现了总裁不为人知的一面，从此两人的关系变得微妙起来。",
    status: "连载中",
    rating: 8.9,
    views: 980000,
    tags: ["恋爱", "职场", "总裁", "韩漫"],
    chapters: [
      { id: "c5-1", title: "第1话 新来的秘书", number: 1, updatedAt: "2026-08-02" },
      { id: "c5-2", title: "第2话 深夜办公室", number: 2, updatedAt: "2026-08-04" },
    ],
    updatedAt: "2026-08-04",
  },
  {
    id: "6",
    slug: "hanman-echi-zuiqiang",
    title: "极道鲜师",
    author: "Lee Hyun",
    category: "韩漫",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20cover%2C%20tough%20female%20teacher%20in%20school%20uniform%20with%20fighting%20stance%2C%20dark%20school%20corridor%20background%2C%20intense%20atmosphere%2C%20dynamic%20illustration%2C%20bold%20color%20contrast&width=600&height=800&seq=manga-cover-06&orientation=portrait",
    description: "曾经的黑道大小姐，为了完成爷爷的遗愿，来到一所问题高中担任教师。面对一群不服管教的学生，她将用自己独特的方式，教会他们什么是真正的强大。",
    status: "已完结",
    rating: 9.3,
    views: 2100000,
    tags: ["热血", "校园", "动作", "韩漫"],
    chapters: [
      { id: "c6-1", title: "第1话 大小姐驾到", number: 1, updatedAt: "2026-07-15" },
      { id: "c6-2", title: "第2话 问题班级", number: 2, updatedAt: "2026-07-16" },
      { id: "c6-3", title: "第3话 第一堂课", number: 3, updatedAt: "2026-07-17" },
    ],
    updatedAt: "2026-07-17",
  },
  {
    id: "7",
    slug: "riman-jinji-shixiong",
    title: "咒术回战",
    author: "芥见下下",
    category: "日漫",
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20manga%20shonen%20action%20cover%2C%20young%20sorcerer%20with%20dark%20energy%20surrounding%2C%20urban%20fantasy%20setting%2C%20dynamic%20fighting%20pose%2C%20bold%20ink-style%20illustration%2C%20dramatic%20black%20and%20red%20color%20scheme&width=600&height=800&seq=manga-cover-07&orientation=portrait",
    description: "少年与诅咒的战斗故事。虎杖悠仁吞下了宿傩的手指，成为了诅咒之王宿傩的容器。为了收集散落各地的宿傩手指，他加入了东京都立咒术高等专门学校，踏上了讨伐诅咒的征程。",
    status: "连载中",
    rating: 9.8,
    views: 5200000,
    tags: ["热血", "战斗", "咒术", "日漫"],
    chapters: [
      { id: "c7-1", title: "第1话 两面宿傩", number: 1, updatedAt: "2026-08-01" },
      { id: "c7-2", title: "第2话 咒术高专", number: 2, updatedAt: "2026-08-02" },
      { id: "c7-3", title: "第3话 初次任务", number: 3, updatedAt: "2026-08-04" },
    ],
    updatedAt: "2026-08-04",
  },
  {
    id: "8",
    slug: "riman-guizi-mie",
    title: "鬼灭之刃",
    author: "吾峠呼世晴",
    category: "日漫",
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20manga%20demon%20slayer%20cover%20art%2C%20young%20swordsman%20with%20blue%20water%20breathing%20effect%2C%20traditional%20Japanese%20taisho%20era%20background%2C%20dramatic%20action%20pose%2C%20beautiful%20ink%20illustration%20style&width=600&height=800&seq=manga-cover-08&orientation=portrait",
    description: "大正时代的日本，少年灶门炭治郎一家被鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了找到让妹妹恢复成人类的方法，炭治郎踏上了成为鬼杀队剑士的道路。",
    status: "已完结",
    rating: 9.9,
    views: 6800000,
    tags: ["热血", "战斗", "鬼杀队", "日漫"],
    chapters: [
      { id: "c8-1", title: "第1话 残酷", number: 1, updatedAt: "2026-07-20" },
      { id: "c8-2", title: "第2话 培育者", number: 2, updatedAt: "2026-07-21" },
      { id: "c8-3", title: "第3话 最终选拔", number: 3, updatedAt: "2026-07-22" },
    ],
    updatedAt: "2026-07-22",
  },
  {
    id: "9",
    slug: "riman-yiquan-chaoren",
    title: "一拳超人",
    author: "ONE / 村田雄介",
    category: "日漫",
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20manga%20one%20punch%20man%20cover%20style%2C%20bald%20hero%20in%20yellow%20costume%20with%20red%20gloves%2C%20explosive%20action%20background%2C%20dynamic%20superhero%20pose%2C%20bold%20clean%20illustration%2C%20vibrant%20comic%20style&width=600&height=800&seq=manga-cover-09&orientation=portrait",
    description: "兴趣使然的英雄——埼玉。经过三年的特训，他获得了无论任何对手都能一拳击败的最强力量。然而过于强大的力量，也让他陷入了找不到对手的苦恼之中。",
    status: "连载中",
    rating: 9.6,
    views: 4100000,
    tags: ["热血", "搞笑", "英雄", "日漫"],
    chapters: [
      { id: "c9-1", title: "第1话 一拳", number: 1, updatedAt: "2026-08-01" },
      { id: "c9-2", title: "第2话 螃蟹怪人", number: 2, updatedAt: "2026-08-03" },
    ],
    updatedAt: "2026-08-03",
  },
  {
    id: "10",
    slug: "guoman-dahua-xiyou",
    title: "大话西游之月光宝盒",
    author: "星辉动漫",
    category: "国漫",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20journey%20to%20the%20west%20cover%2C%20Sun%20Wukong%20monkey%20king%20in%20fantasy%20armor%2C%20mythological%20Chinese%20landscape%20with%20clouds%20and%20palace%2C%20epic%20illustration%20style%2C%20vibrant%20colors%2C%20legendary%20atmosphere&width=600&height=800&seq=manga-cover-10&orientation=portrait",
    description: "改编自经典电影的全新漫画版。至尊宝为救紫霞仙子穿越时空，阴差阳错卷入了一场跨越五百年的爱恨纠葛。当月光宝盒再次开启，命运的齿轮开始转动。",
    status: "连载中",
    rating: 9.1,
    views: 1850000,
    tags: ["奇幻", "西游", "穿越", "国漫"],
    chapters: [
      { id: "c10-1", title: "第1话 月光宝盒", number: 1, updatedAt: "2026-08-01" },
      { id: "c10-2", title: "第2话 穿越时空", number: 2, updatedAt: "2026-08-03" },
    ],
    updatedAt: "2026-08-03",
  },
  {
    id: "11",
    slug: "guoman-wu-shen-zhu-zai",
    title: "武神主宰",
    author: "飞行工作室",
    category: "国漫",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20cover%2C%20powerful%20warrior%20in%20ancient%20Chinese%20armor%20with%20glowing%20fist%2C%20epic%20battlefield%20background%2C%20dramatic%20composition%2C%20bold%20martial%20arts%20illustration%20style&width=600&height=800&seq=manga-cover-11&orientation=portrait",
    description: "秦尘本是武域最年轻的武皇，却被挚爱和兄弟联手背叛。一朝重生，他回到少年时代。这一世，他要将所有背叛他的人踩在脚下，重新登顶武道巅峰！",
    status: "连载中",
    rating: 9.3,
    views: 2340000,
    tags: ["热血", "武侠", "重生", "国漫"],
    chapters: [
      { id: "c11-1", title: "第1话 武皇陨落", number: 1, updatedAt: "2026-08-02" },
      { id: "c11-2", title: "第2话 重生少年", number: 2, updatedAt: "2026-08-03" },
      { id: "c11-3", title: "第3话 再次修炼", number: 3, updatedAt: "2026-08-04" },
    ],
    updatedAt: "2026-08-04",
  },
  {
    id: "12",
    slug: "guoman-fanren-xiu-xian",
    title: "凡人修仙传",
    author: "忘语",
    category: "国漫",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20cultivation%20manhua%20cover%2C%20ordinary%20young%20man%20holding%20a%20glowing%20spirit%20stone%2C%20misty%20mountain%20background%20with%20celestial%20energy%2C%20humble%20hero%20journey%20theme%2C%20clean%20detailed%20illustration&width=600&height=800&seq=manga-cover-12&orientation=portrait",
    description: "一个普通山村少年韩立，凭借自身努力和合理算计，在残酷的修仙界中一步步修炼成仙。没有逆天资质，没有无敌背景，有的只是一颗永不放弃的道心。",
    status: "连载中",
    rating: 9.6,
    views: 4200000,
    tags: ["修仙", "凡人流", "热血", "国漫"],
    chapters: [
      { id: "c12-1", title: "第1话 山村少年", number: 1, updatedAt: "2026-08-01" },
      { id: "c12-2", title: "第2话 七玄门", number: 2, updatedAt: "2026-08-02" },
      { id: "c12-3", title: "第3话 墨大夫", number: 3, updatedAt: "2026-08-04" },
    ],
    updatedAt: "2026-08-04",
  },
];

export const categories = [
  { slug: "hanman", name: "韩漫", icon: "ri-heart-line", description: "韩国精选热门漫画" },
  { slug: "riman", name: "日漫", icon: "ri-star-line", description: "日本经典热血漫画" },
  { slug: "guoman", name: "国漫", icon: "ri-flag-2-line", description: "国风原创优质漫画" },
  { slug: "remen", name: "热门推荐", icon: "ri-fire-line", description: "全网热门漫画推荐" },
];

export const testimonials = [
  {
    id: "t1",
    name: "小明",
    avatar: "ri-user-smile-line",
    rating: 5,
    comment: "亲亲漫画真的是我用过最好的漫画网站！资源超全，更新也很快，每天必刷！",
    date: "2026-07-28",
  },
  {
    id: "t2",
    name: "小红",
    avatar: "ri-user-heart-line",
    rating: 5,
    comment: "韩漫资源非常丰富，而且全部免费！下拉式阅读体验很棒，强烈推荐给喜欢看漫画的朋友。",
    date: "2026-07-25",
  },
  {
    id: "t3",
    name: "阿强",
    avatar: "ri-user-star-line",
    rating: 5,
    comment: "分类很清晰，韩漫日漫国漫都有，找漫画特别方便。画质也很清晰，阅读体验一流！",
    date: "2026-07-20",
  },
  {
    id: "t4",
    name: "小美",
    avatar: "ri-user-voice-line",
    rating: 5,
    comment: "每天都来亲亲漫画追更，更新速度快得惊人。界面简洁干净，没有乱七八糟的广告，爱了爱了！",
    date: "2026-07-18",
  },
  {
    id: "t5",
    name: "大熊",
    avatar: "ri-user-smile-fill",
    rating: 4,
    comment: "国漫资源越来越多了，凡人修仙传和仙逆都有，终于找到了一个靠谱的漫画网站。",
    date: "2026-07-15",
  },
  {
    id: "t6",
    name: "花花",
    avatar: "ri-user-heart-fill",
    rating: 5,
    comment: "朋友推荐来的，一用就停不下来。收藏了好多漫画，每天都有新章节更新，太赞了！",
    date: "2026-07-10",
  },
];

export const faqList = [
  {
    question: "亲亲漫画是否完全免费？",
    answer: "是的，亲亲漫画上所有漫画资源均完全免费，无需付费即可畅享海量韩漫、日漫、国漫资源。我们致力于为广大漫画爱好者提供优质的免费阅读体验。",
  },
  {
    question: "漫画多久更新一次？",
    answer: "亲亲漫画的更新频率取决于各漫画的连载计划。热门漫画通常每日或每周更新，我们会在第一时间同步最新章节，确保读者能够及时追更。",
  },
  {
    question: "支持哪些设备阅读？",
    answer: "亲亲漫画完美支持电脑、平板和手机端阅读。我们的网站采用响应式设计，在任何设备上都能获得流畅的下拉式阅读体验。",
  },
  {
    question: "如何搜索我喜欢的漫画？",
    answer: "您可以通过首页顶部的搜索框输入漫画名称进行搜索，也可以按韩漫、日漫、国漫分类浏览，或者查看热门推荐榜单找到您喜欢的漫画。",
  },
  {
    question: "漫画的清晰度怎么样？",
    answer: "亲亲漫画所有漫画均为高清画质，采用先进的图片压缩技术，在保证清晰度的同时确保加载速度快，让您享受最佳的在线阅读体验。",
  },
];

export const siteStats = {
  totalManga: 5000,
  dailyUpdate: 200,
  totalUsers: 8000000,
  monthlyActive: 3500000,
};